import Layout from '../views/layout/Layout'

export default {
  path: '/demo',
  component: Layout,
  redirect: 'noredirect',
  name: 'demo',
  meta: {
    title: '案例演示管理',
    elicon: 'el-icon-view',
    roles: [],
  },
  children: [
    {
      path: 'app',
      name: 'demo.app',
      component: () => import('@/views/demoShow/appDemo'),
      meta: {
        title: 'Demo APP素材管理',
        roles: ['demo.manage.list'],
      },
    },
  ],
}
